import {
  TOKEN,
  REFRESH_TOKEN,
  USER_EMAIL,
  ACCOUNT_INFO,
  REFERRAL_CODE,
} from '@src/constants/storage'
import jwtDecode from 'jwt-decode'
import { AccountInfo } from '@src/types/account'
export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false
  }
  const decoded = jwtDecode<{ exp: number }>(accessToken)
  const currentTime = Date.now() / 1000

  return decoded.exp > currentTime
}

export function setToken(token: string | null) {
  if (token) {
    localStorage.setItem(TOKEN, token)
  } else {
    localStorage.removeItem(TOKEN)
  }
}

export function setUserEmail(email: string | null) {
  if (email) {
    localStorage.setItem(USER_EMAIL, email)
  } else {
    localStorage.removeItem(USER_EMAIL)
  }
}

export function getUserEmail(): string | null {
  return localStorage.getItem(USER_EMAIL)
}

export function setRefreshToken(refreshToken: string | null) {
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken)
  } else {
    localStorage.removeItem(REFRESH_TOKEN)
  }
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN)
}

export function setAccountInfo(accountInfo: AccountInfo | null) {
  if (accountInfo) {
    localStorage.setItem(ACCOUNT_INFO, JSON.stringify(accountInfo))
  } else {
    localStorage.removeItem(ACCOUNT_INFO)
  }
}

export function getAccountInfo(): AccountInfo | null {
  const accountInfo = localStorage.getItem(ACCOUNT_INFO)
  if (accountInfo) {
    return JSON.parse(accountInfo)
  }
  return null
}

export function getReferralCode(): string | null {
  return localStorage.getItem(REFERRAL_CODE)
}

export function setReferralCode(code: string | null) {
  if (code) {
    localStorage.setItem(REFERRAL_CODE, code)
  } else {
    localStorage.removeItem(REFERRAL_CODE)
  }
}
